import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App"
import { BrowserRouter } from "react-router-dom"
import { DarkmodeProvider } from "./context/themeContext"

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <React.StrictMode>
    <DarkmodeProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </DarkmodeProvider>
  </React.StrictMode>
)
